<!--
    path: src/components/backTop.vue
    author: caozhifu
    time: 2019/5/10
    desc: 回到顶部组件
-->
<template>
     <!--transition标签 按钮出现附带动画-->
      <transition name="el-fade-in">
        <div class="page-component-up" @click="scrollToTop" v-show="toTopShow">
          <i class="el-icon-caret-top"></i>
        </div>
      </transition>
</template>
<script>
export default {
  name: 'BackTop',  // 这个是export出去的组件名，我定义为BackTop
  data () {
    return {
      toTopShow: false,
    }
  },
  methods: {
   handleScroll() {
        //首先修改相对滚动位置
        this.scrollTop = this.scrollTop = window.pageYOffset || document.body.scrollTop
        if (this.scrollTop > 100) {
          this.toTopShow = true
        }else {
          this.toTopShow = false
        }
      },
      scrollToTop() {
        let timer = null, _that = this
        //动画，使用requestAnimationFrame代替setInterval
        cancelAnimationFrame(timer)
        timer = requestAnimationFrame(function fn() {
          if (_that.scrollTop > 0) {
            _that.scrollTop -= 50
            //然后修改这里实现动画滚动效果
            document.body.scrollTop = document.documentElement.scrollTop = _that.scrollTop
            timer = requestAnimationFrame(fn)
          } else {
            cancelAnimationFrame(timer)
            _that.toTopShow = false
          }
        })
      }
    },
    mounted() {
　　　　//$nextTick 避免dom未加载
      this.$nextTick(function () {
        //修改事件监听
        window.addEventListener('scroll', this.handleScroll)
      });
    },
    destroyed() {
      window.removeEventListener('scroll', this.handleScroll)
    }
}
</script>
<style scoped lang="scss">
  .page-component-up{
    background-color: #303133;
    position: fixed;
    right: 30px;
    bottom: 100px;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    cursor: pointer;
    transition: .3s;
    opacity: .6;
    box-shadow: 0 3px 6px rgba(0, 0, 0, .5);
    z-index: 100;
    .el-icon-caret-top{
      color: #fff;
      display: block;
      line-height: 40px;
      text-align: center;
      font-size: 18px;
    }
    p{
      display: none;
      text-align: center;
      color: #fff;
    }
    &:hover{
      opacity: .8;
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/backTop/index.vue